/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import Content from 'app/components/common/Content.jsx';
import SubaccountHeader from 'app/components/Headers/SubaccountHeader.jsx';
import Toggle from 'app/components/common/ToggleControl.jsx';
import FormUtilityMixin from 'app/mixins/FormUtilityMixin.js';
import ErrorModule from 'app/mixins/ErrorModule.jsx';
import FieldError from 'app/components/common/FieldError.jsx';
import FilterMixin from 'app/mixins/FilterMixin.js';
import UserMessages from 'app/modules/UserMessageModule.js';
import SubscriptionModule from 'app/mixins/SubscriptionModule.js';
import classnames from 'classnames';
import * as _ from 'underscore';
import { FormattedDate } from 'react-intl';
import DeleteModal from 'app/components/common/DeleteModal.jsx';
import UncontrolledTextInput from 'app/components/common/UncontrolledTextInput.jsx';
import EmptyState from 'app/components/common/EmptyState.jsx';
import { compose } from 'redux';
import SubaccountProvider from 'app/redux/Providers/SubaccountProvider.jsx';
import Utilities from 'app/utility/Utilities.js';
import FeatureUpgradeComponent from 'app/components/Subscription/FeatureUpgradeComponent.jsx';
import { Breakpoint } from 'react-socks';
import ComponentWithContext from 'app/components/Routers/ComponentWithContext.jsx';

class Users extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            detailId: 0,
            subaccount: {},
            newSubaccount: {},
            errors: null,
            updateMessages: [],
            lastUpdate: ''
        };

        this._getSubaccounts = this._getSubaccounts.bind(this);
        this.createNewSubaccount = this.createNewSubaccount.bind(this);
        this.cancel = this.cancel.bind(this);
        this.detailHandler = this.detailHandler.bind(this);
        this.updateSubaccount = this.updateSubaccount.bind(this);
        this.updateSubaccountEmail = this.updateSubaccountEmail.bind(this);
        this.setSubaccountActiveState = this.setSubaccountActiveState.bind(this);
        this.saveSubaccount = this.saveSubaccount.bind(this);
        this.deleteSubaccount = this.deleteSubaccount.bind(this);
        this.searchUsers = this.searchUsers.bind(this);
        this.onAddUserClick = this.onAddUserClick.bind(this);

    }


    _getSubaccounts() {

        if (!_.isEmpty(this.props.subaccounts.filter)) {
            return this.props.subaccounts.filteredList;
        }

        return  this.props.subaccounts.list;

    }

    static getDerivedStateFromProps(props, state) {
        let nextState = {},
            errors = null;

        errors = props.getApiErrors(['SUBACCOUNT_LIST', 'SUBACCOUNT_UPDATE', 'SUBACCOUNT_CREATE']);
        if (state.errors === null && errors.length) {
            nextState.errors = errors[0];
        } else if (state.errors !== null && errors.length === 0) {
            nextState.errors = null;
        }

        return (Object.keys(nextState).length) ? nextState : null;

    }

    componentDidMount() {
        let id = parseInt(this.props.router.params.subaccountId, 10),
            constants = this.props.app.config.constants;

        // clean up errors from client if present
        this.props.deleteApiError(['SUBACCOUNT_LIST', 'SUBACCOUNT_UPDATE', 'SUBACCOUNT_CREATE', 'SUBACCOUNT_DETACH']);

        if (this.props.app.userLoaded && this.props.user.detail.isAgent === false) {
            if (parseInt(this.props.user.perms.perms.extraSeats, 10) > 0) {
                this.props.getSubaccounts({
                    accountType: constants.SUB_AGENT
                });
            }
        }

        if (id) {
            this.setState({
                detailId: id
            });
        }

        this.props.clearFilter('subaccounts');

    }

    componentDidUpdate(prevProps, prevState) {

        // show the interface for creating new users
        if (prevProps.app.loading.SUBACCOUNT_LIST === true && this.props.app.loading.SUBACCOUNT_LIST === false) {
            if (this.props.subaccounts.list.length === 0 && this.props.router.location.pathname.match('new') === null) {
                this.props.router.navigate('/people/team/new');
            }
            if (this.state.detailId !== 0 && _.isEmpty(this.state.subaccount)) {
                for (let i = 0; i < this.props.subaccounts.list.length; ++i) {
                    if (parseInt(this.state.detailId, 10) === parseInt(this.props.subaccounts.list[i].id)) {
                        this.setState({
                            subaccount: _.clone(this.props.subaccounts.list[i])
                        });
                        break;
                    }
                }
            }
        }

        if (prevState.errors === null && this.state.errors !== null) {
            if (this.state.errors.errors !== undefined && this.state.errors.errors.perms !== undefined) {
                this.props.showUpgradeModal(this.props.closeAllModals, null, this.state.errors, 'team_error');
            }
        }

        if ((prevProps.app.loading.SUBACCOUNT_UPDATE === true && this.props.app.loading.SUBACCOUNT_UPDATE === false) ||
            (prevProps.app.loading.SUBACCOUNT_DELETE === true && this.props.app.loading.SUBACCOUNT_DELETE === false) ||
            (prevProps.app.loading.SUBACCOUNT_CREATE === true && this.props.app.loading.SUBACCOUNT_CREATE === false)) {
            // a new user was created, return to list view
            if (prevProps.subaccounts.list.length < this.props.subaccounts.list.length && this.props.router.location.pathname.match('new') !== null) {
                this.props.router.navigate('/people/team');
                // refresh the user to update the default invitedBy (if necessary)
                this.props.getUser();
                this.props.getUserPerms();
                this.setState({
                    newSubaccount: {}
                });
            } else {
                if (this.state.lastUpdate === 'resetEmail') {
                    this.props.addMessage(UserMessages.generateFlashMessage("We've sent a password reset to your team member.", "SUBACCOUNT_UPDATE"));
                } else if (this.state.lastUpdate === 'resendInvite') {
                    this.props.addMessage(UserMessages.generateFlashMessage("We've resent your invitation.", "SUBACCOUNT_UPDATE"));
                }
                this.setState({
                    lastUpdate: ''
                });
            }

            // check if a user got updated and only rollup the detail if
            // an email has been updated
            if (this.state.detailId !== 0 && this.state.errors === null && this.state.lastUpdate === '') {
                this.setState({
                    detailId: 0,
                    subaccount: {},
                    lastUpdate: ''
                }, () => {
                    this.props.router.navigate('/people/team');
                });
            }
        }

        if (this.props.router.location.pathname.match('new') && this.state.newSubaccount.invitedBy === undefined) {
            this.setState({
                newSubaccount: {
                    invitedBy: this.props.user.detail.name
                }
            });
        }

    }

    createNewSubaccount(e) {
        let constants = this.props.app.config.constants;

        e.preventDefault();

        this.props.deleteApiError(['SUBACCOUNT_CREATE', 'SUBACCOUNT_UPDATE']);
        this.state.newSubaccount.accountType = constants.SUB_AGENT;
        this.props.createSubaccount(this.state.newSubaccount);

    }

    cancel() {

        this.setState({
            detailId: 0,
            subaccount: {},
            newSubaccount: {}
        }, () => {
            this.props.router.navigate('/people/team');
        });

    }

    detailHandler(e) {
        let id = parseInt(e.currentTarget.dataset.id, 10),
            subaccount = {};

        //SubaccountActions.clearMessages('subaccount', id);

        if (id === this.state.detailId) {
            this.setState({
                detailId: 0
            });
            this.props.router.navigate('/people/team');
        } else {
            for (let i = 0; i < this.props.subaccounts.list.length; ++i) {
                if (parseInt(id, 10) === parseInt(this.props.subaccounts.list[i].id)) {
                    subaccount = _.clone(this.props.subaccounts.list[i]);
                    break;
                }
            }
            this.setState({
                detailId: id,
                subaccount
            });
            this.props.router.navigate('/people/team/detail/' + id);
        }

    }

    updateSubaccountEmail(e) {
        let nextSubaccount = _.clone(this.state.subaccount);

        nextSubaccount.email = e.target.value;

        this.setState({
            subaccount: nextSubaccount
        });

    }

    updateSubaccount(e) {
        let subaccount = this.props.subaccounts.list.find((sub) => { return sub.id === this.state.detailId; }),
            field = e.currentTarget.dataset.field;

        e.preventDefault();

        if (subaccount) {
            let nextSubaccount = _.clone(subaccount);
            nextSubaccount[field] = 1;

            this.props.deleteApiError(['SUBACCOUNT_UPDATE']);
            this.props.updateSubaccount(nextSubaccount);

            this.setState({
                lastUpdate: field
            });
        }

    }

    setSubaccountActiveState(e) {
        let state = e.currentTarget.dataset.togglestate === "true" ? 0 : 1,
            subaccount = this.state.subaccount;

        //SubaccountActions.clearMessages('subaccount', subaccount.id);

        subaccount.active = state;

        this.props.updateSubaccount(subaccount);

    }

    saveSubaccount(e) {

        let i = 0,
            subaccount = null;

        e.preventDefault();

        //SubaccountActions.clearMessages('subaccount', this.state.detaiId);
        if (!_.isEmpty(this.state.subaccount)) {
            this.setState({
                errors: null
            }, () => {
                this.props.deleteApiError(['SUBACCOUNT_UPDATE']);
                this.props.updateSubaccount(this.state.subaccount);
            });

        }

    }

    deleteSubaccount(e) {

        let cancelDelete = () => {
                this.props.closeAllModals();
            },
            confirmDelete = (e) => {
                e.preventDefault();
                if (this.state.detailId) {
                    //SubaccountActions.clearMessages('subaccount', this.state.detaiId);
                    this.props.deleteSubaccount(this.state.detailId);
                }
                this.props.closeAllModals();
            },
            modal = (
                <DeleteModal
                    modalCopy={"Are you sure you want to remove this Team Member?"}
                    cancelAction={cancelDelete}
                    confirmAction={confirmDelete} />
            );

        e.preventDefault();

        this.props.addModal(modal);

    }

    searchUsers(e, value) {

        if (value === '') {
            this.props.clearFilter('subaccounts');
        } else {
            this.props.filterStore('subaccounts', 'email', value);
        }

    }

    onAddUserClick(e) {
        e.preventDefault();

        this.props.deleteApiError(['SUBACCOUNT_CREATE', 'SUBACCOUNT_UPDATE']);

        if (this.state.detailId) {
            this.setState({
                detailId: 0,
                newSubaccount: {
                    invitedBy: this.props.user.detail.name
                }
            });
        }

    }

    render() {
        let header = null,
            main = null,
            newUserItem = null,
            statusBlock = null,
            newEmail = (this.state.newSubaccount && this.state.newSubaccount.email) ? this.state.newSubaccount.email : '',
            newInvite = (this.state.newSubaccount && this.state.newSubaccount.invitedBy) ? this.state.newSubaccount.invitedBy : '';

        if (this.props.user.detail.isAgent) {
            let acctMessage = <EmptyState message={"Sorry, only the account owner can access this page."}/>;
            return (
                <Content header={header} main={acctMessage}/>
            );
        }

        if (parseInt(this.props.user.perms.perms.extraSeats, 10) === 0) {
            main = (
                <FeatureUpgradeComponent
                    {...this.props}
                    context="users"/>
            );
            return (
                <Content header={header} main={main}/>
            );
        }

        header = (
            <SubaccountHeader
                {...this.props}
                searchHandler={this.searchUsers}
                recordPath={this.props.recordPath}
                user={this.props.user}
                newSubaccountCallback={this.onAddUserClick} />
        );

        if (this.state.errors) {
            statusBlock = (
                <div className="detail-status error">
                    <ErrorModule
                        app={this.props.app}
                        keys={['SUBACCOUNT_CREATE', 'SUBACCOUNT_UPDATE']}
                        render={(state) => {
                            return (
                                <FieldError field="email" errors={state.errors}/>
                            );
                        }}/>
                    <ErrorModule
                        app={this.props.app}
                        keys={['SUBACCOUNT_CREATE', 'SUBACCOUNT_UPDATE']}
                        render={(state) => {
                            return (
                                <FieldError field="invitedBy" errors={state.errors}/>
                            );
                        }}/>
                </div>
            )
        }

        if (this.props.router.location.pathname.match('new')) {
            newUserItem = (
                <li key="new" className="dlvr-list-item simple detail">
                    <div className="list-item-display">
                        <div className="item-type-icon">
                            <i className="fa fa-user new-subaccount"></i>
                        </div>
                        <div className="item-name common">
                            {(newEmail) ? newEmail : 'New Team Member'}
                        </div>
                    </div>
                    <div className="new-shortener-detail">
                        {statusBlock}
                        <div className="column-container">
                            <form>
                                <div className="editor-panel short">
                                    <fieldset>
                                        <legend>Team Member Email <span className="required">*</span></legend>
                                        <UncontrolledTextInput className="text-input large" placeholder="Invite new team member at email address" defaultValue={newEmail} onChange={FormUtilityMixin.requestChange.bind(this)} data-field="newSubaccount.email" />
                                    </fieldset>
                                    <fieldset>
                                        <legend>Invited By <span className="required">*</span></legend>
                                        <UncontrolledTextInput className="text-input large" defaultValue={newInvite} onChange={FormUtilityMixin.requestChange.bind(this)} data-field="newSubaccount.invitedBy"/>
                                    </fieldset>
                                </div>
                            </form>
                            <div className="explainer-wrapper">
                                <div className="explainer">
                                    <div className="headline">Invite Team Member</div>
                                    <div className="copy">We'll send an invitation to link them to this dlvr.it account.</div>
                                </div>
                            </div>
                        </div>
                        <div className="form-buttons standalone">
                            <div className="cancel-button" onClick={this.cancel} role="button" aria-label="cancel">cancel</div>
                            <button className="btn-primary active fixed" onClick={this.createNewSubaccount}>
                                Invite
                            </button>
                        </div>
                    </div>
                </li>
            );
        }

        main = (
            <ul className="dlvr-list-component">
                {newUserItem}
                {this._getSubaccounts().map(function(subaccount, i) {
                    let inactive = parseInt(subaccount.active, 10) === 2 ? true : false,
                        itemClass = classnames(
            				'dlvr-list-item',
            				{
                                'inactive': inactive,
            					'detail': (subaccount.id === this.state.detailId),
            					'blur': (this.state.detailId !== 0 && this.state.detailId !== subaccount.id)
            				}
                        ),
                        itemNameClass = classnames(
                            'item-name', 'common',
                            {
                                'inactive': inactive
                            }
                        ),
                        statusClass = classnames(
                            "route-status", "common",
                            {
                                'active': inactive === false,
                                'inactive': inactive
                            }
                        ),
                        statusIcon = null,
                        itemDetail = null,
                        statusBlock = null,
                        lastLogin = new Date(subaccount.lastLogin),
                        userActive = (parseInt(subaccount.active, 10) === 2) ? false : true,
                        subaccountIconClass = classnames(
                            'fa', 'fa-user', 'subaccount',
                            {
                                'inactive': inactive
                            }
                        ),
                        subaccountEmail = (this.state.subaccount && this.state.subaccount.email) ? this.state.subaccount.email : '';

                    if (parseInt(subaccount.active, 10) !== 2) {
                        statusIcon = (
                            <div className="route-status-icon">
                                <i className="fa fa-check-circle"/>
                            </div>
                        );
                    }  else {
                        statusIcon = (
                            <div className="route-status-icon">
                                <i className="fa fa-minus-circle"/>
                            </div>
                        );
                    }

                    if (!_.isNaN(lastLogin.getTime()) && parseInt(subaccount.active, 10)) {
                        statusBlock = (
                            <div className="detail-status info">
                                Last Login: <FormattedDate
                                                value={lastLogin}
                                                day="numeric"
                                                month="long"
                                                year="numeric"/>
                            </div>
                        );
                    } else {
                        if (_.isNaN(lastLogin.getTime()) && parseInt(subaccount.active, 10)) {
                            statusBlock = (
                                <div className="detail-status inactive">
                                    Team Member has not logged in.
                                </div>
                            );
                        }
                    }

                    // if (this.state.updateMessages && this.state.updateMessages.length) {
                    //     statusBlock = (
                    //         <div className="detail-status info">
                    //             {this.state.updateMessages.map(function(message, i) {
                    //                 return (<div key={i}>{this.getUserMessage(message)}</div>);
                    //             }, this)}
                    //         </div>
                    //     )
                    // }

                    if (subaccount.id === this.state.detailId) {
                        itemDetail = (
                            <div>
                                <Breakpoint desktop only>
                                    <div className="detail-controls">
                                        <div className="detail-toggle">
                                            <Toggle
                                                active={userActive}
                                                noLabel={true}
                                                callback={this.setSubaccountActiveState} />
                                        </div>
                                        <div className="detail-buttons">
                                            <div className="detail-button" onClick={this.deleteSubaccount} data-id={subaccount.id} role="button" aria-label="remove user">
                                                <div className="button-icon">
                                                    <i className="fa fa-remove"></i>
                                                </div>
                                                <div className="button-label">
                                                    Delete
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Breakpoint>
                                <Breakpoint mobile only>
                                    <div className="detail-controls mobile">
                                        <div className="detail-control-row">
                                            <div className="detail-toggle">
                                                <Toggle
                                                    active={userActive}
                                                    callback={this.setSubaccountActiveState} />
                                            </div>
                                            <div className="detail-button" onClick={this.deleteSubaccount} data-id={subaccount.id} role="button" aria-label="remove user">
                                                <div className="button-icon">
                                                    <i className="fa fa-remove"></i>
                                                </div>
                                                <div className="button-label">
                                                    Delete
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Breakpoint>
                                {statusBlock}
                                <div className="editor-panel short">
                                    <fieldset>
                                        <legend>Team Member's Email <span className="required">*</span></legend>
                                        <UncontrolledTextInput className="text-input medium" defaultValue={subaccountEmail} onChange={this.updateSubaccountEmail} data-field="email"/>
                                        <div style={{margin: '40px 0'}}>
                                            <button className="btn-secondary fixed" onClick={this.updateSubaccount} data-field="resendInvite">
                                                Resend Invite Email
                                            </button>
                                        </div>
                                        <div style={{margin: '40px 0'}}>
                                            <button className="btn-secondary fixed" onClick={this.updateSubaccount} data-field="resetEmail">
                                                Send Password Reset Email
                                            </button>
                                        </div>
                                    </fieldset>
                                    <fieldset>
                                        <div className="form-buttons">
                                            <div className="cancel-button" onClick={this.cancel} role="button" aria-label="cancel">cancel</div>
                                            <button className="btn-primary active fixed" onClick={this.saveSubaccount}>
                                                Save
                                            </button>
                                        </div>
                                    </fieldset>
                                </div>
                            </div>
                        )
                    }

                    return (
                        <li key={i} className={itemClass}>
                            <div className="list-item-display"
                                onClick={this.detailHandler}
                                data-id={subaccount.id}
                                role="switch"
                                aria-label="show details">
                                <div className="item-type-icon">
                                    <i className={subaccountIconClass}></i>
                                </div>
                                <div className={itemNameClass}>
                                    {subaccount.email}
                                </div>
                                <div className={statusClass}>
                                    {statusIcon}
                                </div>
                            </div>
                            {itemDetail}
                        </li>
                    );
                }, this)}
            </ul>
        );

        return (
            <Content header={header} main={main} />
        );
    }

};

Users.displayName = "Users";

Users.propTypes = {
    userPerms: PropTypes.object,
    routeViewType: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    recordPath: PropTypes.func,
    trialEligible: PropTypes.bool
};

Users.defaultProps = {
    userPerms: {},
    routeViewType: 0,
    recordPath: null,
    trialEligible: false
};

const enhance = compose(
    ComponentWithContext,
    SubaccountProvider
);

export default enhance(Users);
